import * as React from 'react';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import './LabelWithQuestionIcon.scss';

interface Props {
  hintText: string;
  labelText: React.ReactNode;
  customClass?: string;
  customLabelClass?: string;
  labelHtmlFor?: string;
}

export function LabelWithQuestionIcon(props: Props) {
  const { hintText, labelText, labelHtmlFor, customClass, customLabelClass } = props;
  const questionIconClass = classNames('d-flex justify-content-start', customClass);

  return (
    <div className={questionIconClass}>
      <label htmlFor={labelHtmlFor} className={customLabelClass}>
        {labelText}
      </label>
      {hintText && <span className="eFieldInlineHint">{hintText}</span>}
    </div>
  );
}
